import { UserState } from './user-state';

/**
 * The class to read user state data from local storage
 */
export class UserStateStorageReaderService {
	/** The local storage key used to save the user state. */
	private static readonly LOCAL_STORAGE_KEY: string = "crownx-user-state";

	/**
	 * @constructor
	 * Private constructor to prevent this class from being instantiated because typescript doesn't support static classes.
	 */
	private constructor() { }

	/**
	 * Get user state from localStorage.
	 * @returns The user state data.
	 */
	public static GetUserState(): UserState | null {
		const stateJson = localStorage.getItem(UserStateStorageReaderService.LOCAL_STORAGE_KEY);
		if (stateJson) {
			return JSON.parse(stateJson);
		}
		return null;
	}
}
